<template>
  <div class="wrapper list" :endpoint='widget.endPoint'>
    <div class="scroller">
      <div class="button-holder">
        <template v-for="(button, i) in buttons">
          <div class="col-md-3" v-if="isVisible(button)">
            <ed-button class="btn btn-actionbar shortcut-btn"
                      :key='i'
                      :title="getLabel(button).fullText"
                      @click="handleClick(button)">
              {{getLabel(button).shortText}}
            </ed-button>
          </div>
        </template>
      </div>
    </div>
    <addDivisionModal :show="showAddDivision" @close="closeDivisionModal" />
  </div>
</template>

<script>
  import { EventBus } from '@/event-bus'
  import user from '@/core/user'
  import addDivisionModal from './addDivisionModal.vue'
  import { singularize } from '@/core/utils/string.js'

  export default {
    components: {
      addDivisionModal
    },
    alias: 'shortcuts-wdg-cmp',
    name: 'shortcuts',
    isApple: false,

    props: { widget: Object },

    created() {
      const vendorId = global.app.$user.$.data && global.app.$user.$.data.VendorID
      this.isApple = (vendorId / 1 === 44764)
      this.companySettings = user.getCompanySettings()
      this.init()

      EventBus
      .$off('DASHBOARD_READY')
      .$on('DASHBOARD_READY', () => {
        this.init()
      })
    },

    data() {
      return {
        buttons: [],
        companySettings: {},
        showModal: false,
        showAddDivision: false
      }
    },

    methods: {
      init() {
        this.api.get(this.widget.endPoint, {})
          .then(r => {
            this.buttons = [...r.data]
            if (this.isApple) {
              this.buttons = this.buttons.filter(function (value, index, arr) { return value !== 'CreateProgram' && value !== 'CreatePO' })
            }
            this.$nextTick(() => {
              if (this.buttons.length > 4) {
                EventBus.$emit('updateWidgetHeightSimple', {
                  wId: this.widget.id,
                  height: this.$el.clientHeight + 6,
                  explicitS: 2
                })
              }
            })
          })
      },

      getProgramLabel() {
        return this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program'
      },

      getLabel(button) {
        let label = ''
        switch (button) {
          case 'CreateProgram': label = 'Create ' + this.getProgramLabel(); break
          case 'CreatePO': label = 'Create PO'; break
          case 'CreateSavingsPO': label = 'Create Savings PO'; break
          case 'UploadInvoice': label = 'Submit Invoice'; break
          case 'AddSupplier': label = 'Add Supplier'; break
          case 'CreateNewDivision': label = 'Create new ' + singularize(this.$root.getUser.settings.Labels.DivisionName); break
        }
        let words = label.split(' ')
        let shortLabel = words.length > 3 ? words.slice(0, 3).join(' ') + '...' : label
        return { fullText: label, shortText: shortLabel }
      },

      handleClick(button) {
        const isEmbedded = window.self !== window.top
        if (isEmbedded && button !== 'CreateNewDivision') {
          window.parent.postMessage(
            {
              type: 'LEGACY_SHORTCUT_CLICK',
              button
            },
            '*'
          )
          return
        }
        switch (button) {
          case 'CreateProgram': this.$router.push('/i/Programs/Program-list/?goto=ProgramFusion/ProgramInfo'); break
          case 'CreatePO': this.$router.push('/i/Programs/PO-sent/?goto=ScopeOfService/Detail/0/1/0'); break
          case 'CreateSavingsPO': this.$router.push('/i/Programs/PO-sent/?goto=ScopeOfService/Detail/0/1/0/0/0?isHotel=1'); break
          case 'UploadInvoice': this.$router.push('/d/InvoiceToPay/upload?invoiceId=0&from=myDashboard'); break
          case 'AddSupplier': this.$router.push('/d/Network/add-supplier/'); break
          case 'CreateNewDivision':
            this.showAddDivision = true
            break
        }
      },

      isVisible(button) {
        return true
      },

      closeDivisionModal() {
        this.showAddDivision = false
      }
    }
  }

</script>
<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";

  .col-md-3 {
    padding: 0 2px;
    font-size: 11px;
    margin-bottom: 10px;
  }

  .button-holder {
    margin-top: 8px;
  }

  .btn.btn.btn-primary.shortcut-btn {
    color: $href-blue-color;
    border-color: $href-blue-color;
    &:hover

  {
    color: darken($href-blue-color, 18) !important;
    border-color: darken($href-blue-color, 18) !important;
  }

  }

  .wrapper {
    min-height: 30px;
    height: auto;
    max-height: 200px;
  }

  .scroller {
    min-height: 30px;
    height: auto;
    max-height: 200px;
    position: relative;
    padding-right: 10px;
    overflow-y: hidden;
  }

  .btn {
    content: attr(data-fulltext);
    width: 100%;
    margin: 0;
    height: 3.6em;
    font-size: 13px !important;
    white-space: inherit;
    overflow: hidden;
    line-height: 1.2em;
    padding: 8px 20px !important;
   }
</style>




// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/Shortcuts/index.vue